export default {
  "foot": {
    "title": "Century Games 玩家",
    "p1": "輸入帳號後，您可選擇商品購買。若未入帳可嘗試重啟遊戲，或聯繫遊戲客服。",
    "p2": "若有疑問，請聯繫遊戲客服，感謝您的支持！",
    "copyright": "© Copyright 2024 Century Games.",
    "service": "服務協議",
    "policy": "隱私政策",
    "descriptionTitle": "充值說明"
  },
  "accept": {
    "title": "我們使用必要的cookies 以提供服務並改善您的體驗，更多資訊，請參閱我們的<a href=\"https://www.centurygames.com/zh/privacy-policy/\" style=\"color: #58a8a5 ;\">隱私政策</a>。",
    "decline": "拒絕",
    "accept": "接受"
  },
  "game": {
    "inapptext": "透過遊戲登入",
    "loginfail": "登入失敗",
    "logintip": "若授權失敗，請將遊戲應用程式更新到最新版本，或嘗試使用其他瀏覽器存取網站。",
    "reloadmsg": "請點擊「重新載入」以取得登入結果",
    "reload": "重新載入",
    "appnotice": "若您想要透過遊戲授權登入，請使用外部瀏覽器造訪網站。",
    "changeaccount": "確定要登出嗎？",
    "login": "登入",
    "notice": "提醒",
    "confirm": "確認",
    "loginuserid": "帳號",
    "palceholder": "輸入帳號",
    "okbtn": "確認",
    "loginbtn": "遊戲授權",
    "changebtn": "帳號登入",
    "useTitle": "帳號",
    "checkBtn": "確認",
    "findid": "找不到您的帳號？",
    "checktext": "帳號通常顯示在設定中，可點擊問號標誌以取得更多資訊。",
    "username": "暱稱：",
    "userId": "帳號：",
    "packageTitle": "選擇商品",
    "edit": "修改",
    "paymentTitle": "付款方式",
    "total": "總價",
    "goPay": "付款",
    "noSelectPackageTips": "請先選擇商品",
    "payFail": "付款失敗",
    "camelPayfail": "付款失敗",
    "payFailTips1": "若需協助，請聯繫 Adyen 客服",
    "payFailTips2": "若需協助，請聯繫 PayPal 客服",
    "paySuccess": "付款成功",
    "paySuccessTips2": "若商品未入帳，請重新啟動遊戲或聯繫客服！",
    "camelPaySuccess": "付款成功",
    "transactionId": "訂單 ID",
    "paySuccessTips": "商品發貨可能有延遲，請稍候",
    "deliveryFail": "商品發貨失敗",
    "deliveryFailTips": "若需協助，請聯繫遊戲客服",
    "orderTitle": "訂單資訊",
    "paidWith": "付款方式",
    "orderID": "訂單 ID",
    "payStatus": "付款狀態",
    "orderTotal": "總價",
    "transactionDate": "訂單時間",
    "goOnPay": "再買一筆",
    "getInvoice": "收據",
    "camelDeliveryFail": "商品發貨失敗",
    "confirmOrder": "確認訂單",
    "confirmFollow": "請確認下列資訊：",
    "nickname": "暱稱",
    "packageName": "商品",
    "totalPayment": "總價",
    "confirmPayWith": "付款方式",
    "confirmAndGoOn": "確認並付款",
    "orderCancel": "取消",
    "getInvoiceTitle": "透過郵件寄送",
    "getInvoiceTips": "請提供信箱以取得收據",
    "getInvoiceTips1": "請填寫信箱",
    "getInvoiceTips2": "同意記錄您的信箱",
    "getInvoiceTips3": "同意收到折扣、促銷、遊戲活動等郵件",
    "invoiceSend": "發送",
    "sendSuccess": "發送成功",
    "id404": "帳號不存在",
    "packageLoadingText": "商品更新中",
    "taxTips": "價格含稅",
    "adyenTips": "付款服務由 Adyen 提供，該公司持有銀行執照，並由荷蘭中央銀行監管。若對其認證有任何疑問，請參閱<a href=\"https://www.adyen.com/platform/certifications\">https://www.adyen.com/platform/certifications</a>，若需了解其使用者資料保護政策，請參閱<a href=\"https://www.adyen.com/policies-and-disclaimer/privacy-policy\">https://www.adyen.com/policies-and-disclaimer /privacy-policy</a>。",
    "paypalTips": "付款服務由 PayPal 提供。若欲了解其使用者資料保護政策，請參閱<a href=\"https://www.paypal.com/c2/webapps/mpp/ua/privacy-full\">https://www.paypal.com/c2 /webapps/mpp/ua/privacy-full</a>。",
    "switchCountryTips": "您常用的國家/地區為 ${servercountry}，是否切換國家及幣種?",
    "paypalBtn": "刷卡付款",
    "paypalOr": "或",
    "paypalCard1": "持卡人姓名（選填）",
    "paypalCard2": "卡號",
    "checkUserID": "連結",
    "success": "成功",
    "changeCurrencyContent": "確定要切換區域和貨幣以符合您遊戲內的設定：${servercountry}嗎？",
    "productDescription": "農富幣是以現金付款後取得的貨幣，用於購買遊戲中的禮包和優惠商品。",
    "payButton": "付款",
    "userIdNotice": "請先輸入您的帳號以連結",
    "account": "帳號",
    "card": "金融卡",
    "notification": "輸入您的帳號以連結，選擇欲購買的商品後用首選支付方式付款。重新讀取遊戲，購買的商品即會存入帳號中供使用。\n\n若您有任何疑問，歡迎隨時在遊戲內使用客服系統與我們聯繫。",
    "rongluRank": "熔爐等級：",
    "tips": "如何使用？",
    "checkTIps1": "我已閱讀並同意<a :href=\"policyUrl\">《隱私政策》</a>、<a :href=\"serviceURl\">《服務協議》</a>及<a :href=\"paymentURl\"> 《支付條款》</a>。",
    "checkTIps2": "請閱讀並勾選協議",
    "selectTips": "（將自動選擇您最近在遊戲中儲值所使用的幣種）",
    "koPayTips": "若您的金融卡使用了境外韓幣結帳服務（DCC），會產生額外的手續費，該費用由第三方代理收取，而非本網站。",
    "PayTips": ""
  },
  "invoice": {
    "title": "付款收據",
    "transactionId": "訂單 ID",
    "transactionDate": "訂單時間",
    "totalAmount": "總價",
    "paymentMethod": "付款方式",
    "description": "描述",
    "game": "遊戲",
    "quantity": "商品數量",
    "price": "價格",
    "amount": "總價",
    "total": "總價",
    "footTitle": "備註",
    "footContent": "感謝您對 Century Games 的支持！",
    "button1": "索取收據",
    "button2": "不領取收據返回",
    "giveupInvoice": "您將無法收到該訂單的收據。確認不需要收據嗎？"
  },
  "payment": {
    "card": "信用卡/簽帳金融卡",
    "paypal": "PayPal"
  },
  "country": {
    "countryTitle1": "國家/地區",
    "Africa": "非洲",
    "America": "美洲",
    "Asia": "亞洲",
    "Europe": "歐洲",
    "Oceania": "大洋洲",
    "ZA": "南非",
    "US": "美國",
    "HK": "中國香港",
    "JP": "日本",
    "KR": "韓國",
    "SG": "新加坡",
    "SA": "沙烏地阿拉伯",
    "IQ": "伊拉克",
    "TW": "中國台灣",
    "TH": "泰國",
    "GB": "英國",
    "AU": "澳洲",
    "countryLanguage1": "語言",
    "AE": "阿拉伯聯合大公國",
    "DE": "德國",
    "PT": "葡萄牙",
    "RU": "俄羅斯",
    "ES": "西班牙",
    "CH": "瑞士",
    "TR": "土耳其",
    "KW": "科威特",
    "QA": "卡達",
    "PL": "波蘭",
    "ID": "印度尼西亞",
    "IT": "義大利",
    "IN": "印度",
    "FR": "法國",
    "CA": "加拿大",
    "NL": "荷蘭",
    "AT": "奧地利",
    "RS": "塞爾維亞",
    "SE": "瑞典",
    "MY": "馬來西亞",
    "BE": "比利時",
    "DK": "丹麥",
    "FI": "芬蘭",
    "PH": "菲律賓",
    "NO": "挪威",
    "BR": "巴西",
    "NZ": "紐西蘭",
    "UA": "烏克蘭",
    "RO": "羅馬尼亞"
  },
  "extra_info": {
    "kingdom": "所在王國："
  },
  "adyen": {
    "note": "本金流服務由 Adyen 提供，通過 PC-DSS 國際信用卡組織最高等級認證，提供安全的交易服務，支援國內外刷卡。",
    "note2": "注意：勾選“儲存以便下次付款使用”，僅在目前瀏覽器中儲存個人信用卡資訊。"
  },
  "pay": {
    "error1": "若是付款發生問題，請稍後重試或更換付款方式。如有疑問，請聯絡客服。"
  },
  "meta": {
    "title": "《菲菲大冒險》商店",
    "description": "《菲菲大冒險》商店是《菲菲大冒險》官方開設的商店，旨在提供您優惠的儲值方式和遊戲內禮包販售。",
    "keywords": "農場、莊園、種植、市場、升等、升級、探索、地圖、角色、等級、模擬、策略、支付、商店、儲值、付款"
  }
};


// WEBPACK FOOTER //
// ./src/lang/zh-Hant.js